import { render } from "./project_job.vue?vue&type=template&id=b1a56956&scoped=true"
import script from "./project_job.vue?vue&type=script&lang=js"
export * from "./project_job.vue?vue&type=script&lang=js"

import "./project_job.vue?vue&type=style&index=0&id=b1a56956&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1a56956"]])

export default __exports__